//#region ------------ function shorthand -------------------------
var getByID = (element)=>{return document.getElementById(element)}
var getByClass = (element)=>{return document.querySelector('.'+element)}
var getByClassAll = (element)=>{return document.querySelectorAll('.'+element)}
//#endregion ----------------------

window.onload = function() {
    var $recaptcha = getByID('g-recaptcha-response');
    if($recaptcha) {
        $recaptcha.setAttribute("required", "required");
    }
        
    // if ($recaptcha.getResponse() == ""){
    //     alert("You can't proceed!");
    // } else {
    //     alert("Thank you");
    // }
};

var dateTime = new Date();
var timestamp = dateTime.getDate()+""+dateTime.getMonth()+""+dateTime.getFullYear()+""+dateTime.getHours()+""+dateTime.getMinutes()+""+dateTime.getSeconds();

deleteListFileBtn = (e)=>{
    var listID = getByID(e.getAttribute('data-target'));
    listID.remove();
}

getFile = (filePath)=>{
    return filePath.substr(filePath.lastIndexOf('\\') + 1).split('.')[0];
}

getoutput =()=>{
    var fileBox = getByID('file-box');
    var cutFileName = getFile(file_complainant.value).length > 12 ? getFile(file_complainant.value).slice(0, 12)+"...":getFile(file_complainant.value);
    var tooltipNameFile = getFile(file_complainant.value).length > 12 ? "data-bs-toggle='tooltip' data-bs-placement='bottom' title='"+getFile(file_complainant.value)+"."+file_complainant.value.split('.')[1]+"'":"";
    var typeFile = ["PDF","pdf","JPG","jpg","jpeg"];
    if(typeFile.includes(file_complainant.value.split('.')[1])){
    fileBox.innerHTML += "<div id='file-upload-"+timestamp+"' class='d-flex align-items-center rounded-3 py-2 ps-3 pe-4 list-file-box m-1' "+tooltipNameFile+"><i class='fas fa-times delete' onclick='deleteListFileBtn(this)' data-target='file-upload-"+timestamp+"'></i><i class='far fa-file-pdf fs-5 pe-2'></i><span class='font-prompt fw-400'>"+cutFileName+"."+file_complainant.value.split('.')[1]+"</span></div>";}
}

var surveyCheckbox = getByClassAll('survey-chcekbox');
surveyCheckbox.forEach((checkbox)=>{
    checkbox.addEventListener('change',(e)=>{        
        const idCheckbox = e.target.id;
        const idTextbox = idCheckbox+'_detail';
        const textbox = getByID(idTextbox);
        if (textbox) {
            if (textbox.disabled) {
                textbox.disabled = false;
                textbox.setAttribute("required", "required");
                textbox.focus();
            } else {                
                textbox.disabled = true;                
                textbox.removeAttribute("required");
            }
        }
    })
});
